import React from 'react';

const BSC_ORANGE = '#F28C28';
const BSC_GREEN = '#1AA84B';

const LETTER_COLORS = [BSC_ORANGE, '#FFFFFF', BSC_GREEN];

export function StripedWordmark({ text, size = 'md' }) {
  const sizeMap = {
    sm: 'text-[28px] sm:text-[34px]',
    md: 'text-[36px] sm:text-[44px] md:text-[52px]',
    lg: 'text-[48px] sm:text-[60px] md:text-[76px] lg:text-[88px]',
  };
  return (
    <div
      className={`flex items-end justify-center gap-[2px] leading-none ${sizeMap[size]}`}
      style={{ fontFamily: "'Monoton', cursive" }}
    >
      {text.split('').map((ch, i) => {
        const color = LETTER_COLORS[i % LETTER_COLORS.length];
        return (
          <span
            key={i}
            style={{
              color,
              textShadow: `0 0 14px ${color}55, 0 0 2px ${color}88`,
              letterSpacing: '0.02em',
            }}
          >
            {ch}
          </span>
        );
      })}
    </div>
  );
}

export function TricolorStrip({ className = '' }) {
  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <div className="h-[2px] flex-1 rounded-full" style={{ backgroundColor: BSC_ORANGE }} />
      <div className="h-[2px] flex-1 rounded-full bg-white" />
      <div className="h-[2px] flex-1 rounded-full" style={{ backgroundColor: BSC_GREEN }} />
    </div>
  );
}

export default function BSCAuthLayout({ children, wordmark = 'BUDGETS' }) {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center relative overflow-hidden px-6 py-10"
      style={{ backgroundColor: '#000', fontFamily: 'Manrope, sans-serif' }}
    >
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            'radial-gradient(circle at 20% 20%, rgba(242,140,40,0.08), transparent 45%), radial-gradient(circle at 80% 80%, rgba(26,168,75,0.08), transparent 45%)',
        }}
      />

      <div className="relative z-10 flex flex-col items-center gap-6 w-full max-w-md">
        <img
          src="/bsc-logo.jpeg"
          alt="BSC"
          className="w-20 h-20 rounded-xl shadow-[0_0_40px_rgba(255,255,255,0.06)] select-none"
          draggable={false}
        />
        <TricolorStrip className="w-40" />
        <StripedWordmark text={wordmark} size="md" />
        <p className="text-white/50 text-[10px] tracking-[0.35em] uppercase">
          BSC Business OS
        </p>

        <div
          className="w-full mt-4 rounded-2xl border border-white/10 bg-white/[0.03] p-8 backdrop-blur-sm"
          data-testid="auth-card"
        >
          {children}
        </div>
      </div>

      <div className="absolute bottom-4 left-0 right-0 text-center text-white/30 text-[10px] tracking-widest uppercase z-10">
        &copy; {new Date().getFullYear()} BSC &middot; All rights reserved
      </div>
    </div>
  );
}

export { BSC_ORANGE, BSC_GREEN };
